<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}
.lang-width {
  width: 450px !important;
}
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb1"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">充电桩品类绑定列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="list-query-child-div flex" style="align-items:center;">
          <div  style="font-size:20px;font-weight:800;">电商私桩绑定总数：{{ all| numberToCurrency }}</div>
           
        </div>
        
        <div class="flex-grow-1"></div>
        <!-- <button class="common-bg-button" @click="getListData(pagination, true)">
          搜 索
        </button>
        <button class="common-bg-button" @click="reset()">重 置</button> -->
        <button class="common-bg-button" @click="toExportList()">导出</button>
      </div>

      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns1"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      all:'',
      tableData: [], // 表格数据
      selections: [], // 表格选项
      searchTime: [],
      radio:'',
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      paidTime: [],
      showMultiQuerys: false,
      operates: {
        width: 220,
        fixed: "right",
        list: [
          
        ],
      }, // 列操作按钮
    };
  },
  methods: {
   //获取数据
   init() {
      this.getListData(this.pagination, true);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      // _.queryInfo.corpNo = _.$store.state.corpNo;
      // if( !_.searchTime||_.searchTime.length<=0){
      //   return _.$U.error("请选择时间范围");
      // }
      // if(!_.queryInfo.filterType){
      //   return _.$U.error("请选择类型");
      // }
      _.$U.showLoading(_);
      _.$H
        .post(_, _.$A.operateStatis.pileProductBindPage, _.queryInfo)
        .then((res) => {
          _.tableData = res.data.data.content || [];
          _.all= _.tableData[0].bindCountAll
          
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
    },
    // 选择注册时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.startDate = val[0];
        this.queryInfo.endDate = val[1];
      } else {
        delete this.queryInfo.startDate;
        delete this.queryInfo.endDate;
      }
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    //选择时间
    pickdate(time) {
      console.log(time);
      let _ = this;
      // 拆分时间区间
      _.queryInfo.fromTransactionSucceedTime = time ? time[0] : "";
      _.queryInfo.toTransactionSucceedTime = time ? time[1] : "";
    },
     // 导出
     toExportList() {
      let _ = this;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.operateStatis.pileProductBind, {}).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        var downUrl = 'http://192.168.8.174:7997'+res.data.data.viewPath;
        // var downUrl = 'http://ocharge.shzhida.com:6777'+res.data.data.viewPath;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },
    //重置
    reset() {
      delete this.queryInfo.filterType;
      delete this.queryInfo.startDate;
      delete this.queryInfo.endDate;
      this.filterType = ''
      this.searchTime = [];
      this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
